// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.app-container {
  display: flex;
  flex-direction: column;
}

.custom-toast {
  position: relative; /* Изменяем позиционирование, чтобы элемент занимал место */
  width: 100%; /* Занимаем всю ширину контейнера */
  z-index: 1; /* Убедитесь, что z-index не перекрывает другие важные элементы */
}

.custom-toast .ui-toast {
  margin: 0 auto; /* Центрируем элемент */
  width: auto; /* Автоматическая ширина */
}

.custom-toast .ui-toast-message {
  width: 100%;
}

:host ::ng-deep .custom-toast .p-toast-message {
  width: 100%;
}

:host ::ng-deep .custom-toast .p-toast-message-content {
  width: 100%;
}

.c-sidebar-ustas {
  padding-top: 117px;
}

.c-main-content-ustas {
  margit-top: 54px;
}

.header-wrapper {
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 1001;
}
.c-navbar {
  position: relative;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
